import { render, staticRenderFns } from "./UnsubscriptionAnnounce.vue?vue&type=template&id=a1340526&scoped=true"
import script from "./UnsubscriptionAnnounce.vue?vue&type=script&lang=ts"
export * from "./UnsubscriptionAnnounce.vue?vue&type=script&lang=ts"
import style0 from "./UnsubscriptionAnnounce.vue?vue&type=style&index=0&id=a1340526&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1340526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1340526')) {
      api.createRecord('a1340526', component.options)
    } else {
      api.reload('a1340526', component.options)
    }
    module.hot.accept("./UnsubscriptionAnnounce.vue?vue&type=template&id=a1340526&scoped=true", function () {
      api.rerender('a1340526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/UnsubscriptionAnnounce.vue"
export default component.exports